"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

export default function TranslateOnRouteChange() {
  const pathname = usePathname();

  useEffect(() => {
    if (window.google?.translate?.TranslateElement) {
      setTimeout(() => {
        new window.google.translate.TranslateElement(
          { pageLanguage: "en" },
          "google_translate_element"
        );
      }, 400);
    }
  }, [pathname]);

  return null;
}
